import * as React from "react";
import { Form, Segment, Grid, Header, List, Dropdown, Message, DropdownItemProps, MessageList, MessageHeader, MessageItem, GridRow, GridColumn, FormField, ListItem, FormTextArea } from "@/components/bp/bp-ui";
import { Formik, Field, FormikProps } from "formik";
import * as yup from "yup";
import { TranslationContext } from "../../../Contexts/TranslationContext";
import { GenerateSampleCaseRunCreateModel } from "@app/api2/api";
import SemanticField from "@app/components/SemanticField";
import { Constants } from "../../Constants";
import { BPButton } from "@/components/bp/bpbutton";
import { BPCheckbox } from "@/components/bp/bpcheckbox";

interface IInformationGenerateSampleProps {
    model: GenerateSampleCaseRunCreateModel;
    onComplete: (values: any) => void;
    // router: any;
}

class InformationGenerateSampleState {
    initialValues: FormState;
    populationOptions: DropdownItemProps[];
}

// export type FormState = Omit<GenerateSampleCaseRunCreateModel, 'aic' | 'hpUnknowns' | 'hp' | 'hasSelectedSystems' | 'hpNumberOfContributors'> & {

// };

export type FormState = Pick<GenerateSampleCaseRunCreateModel, 'hdUnknowns' | 'hd' | 'description' | 'numberOfContributors' | 'hdNumberOfContributors' | 'populationId' | 'hdKnownRelName' | 'hdKnownRelSampleId'> & {

};

export class InformationGenerateSample extends React.Component<IInformationGenerateSampleProps, InformationGenerateSampleState> {
    

    FormValidationSchema: () => yup.SchemaOf<FormState>;

    form: any = React.createRef();

    constructor(props, context) {
        super(props, context);

        this.FormValidationSchema = () => yup.object().shape({
            caseName: yup.string(),
            description: yup.string().label(window.translation.caseRun.runDescription),
            // unknowns: yup.number().min(0).integer().max(Constants.maxUnknowns).required().label(window.translation.caseRun.unknowns),
            populationId: yup.number().required().label(window.translation.common.population),
            createdFromPrevious: null,
            discriminator: null,
            efmCaseId: null,
            evidence: null,
            evidenceSystems: null,
            hd: null,
            hdKnownRelName: null,
            hdKnownRelSampleId: null,
            hdNumberOfContributors: null,
            hdUnknowns: null,
            labId: null,
            numberOfContributors: null,
            oldRunId: null,
            parameters: null,
            populations: null,
            runType: null,
            sampleSystems: null,
            useHd: null,
            useHp: null
        });

        this.state = {
            initialValues: {
                ...this.props.model,
                description: this.props.model.description || "",
                numberOfContributors: this.props.model.numberOfContributors,
                populationId: this.props.model.populationId && this.props.model.populations.some(x => x.id == this.props.model.populationId) ? this.props.model.populationId : null,
            },
            populationOptions: this.props.model.populations.map((p) => ({ key: p.id, value: p.id, text: p.name }))
        };
    }

    calcUnknown = (nocMin: number, nocMax: number, contributors: Array<{ selected: boolean }>): string => {
        let unknowns: Array<number> = [];
        for (let noc = nocMin; noc <= nocMax; noc++) {
            let unknown = noc;
            unknown = noc - (contributors || []).filter(h => h.selected).length;
            unknowns.push(unknown);
        }

        if (unknowns.length == 1)
            return unknowns[0].toString()

        return unknowns.join("-");
    }

    formRender = ({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldTouched, setFieldValue }: FormikProps<FormState>) => {
        // var state = this.state;
        const dropdownChange = async (e, data, name?) => {
            if (name) {
                await setFieldValue(name, data.value);
                if (name == "numberOfContributors") {
                    // this.recalc(data.value, data.value)
                    await recalcUnknownHd(data.value, data.value);
                }
            } else {
                await setFieldValue("populationId", data.value);
            }
        };

        const hdChecked = async (id, i, value: boolean) => {
            const hp = values.hd;
            hp[i].selected = value;
            await setFieldValue("contributors", hp);
            await recalcUnknownHd(values.numberOfContributors, values.numberOfContributors)
        }

        const recalcUnknownHd = async (nocMin, nocMax) => {
            await setFieldValue('hdUnknowns', this.calcUnknown(nocMin, nocMax, values.hd));
            this.setState({ ...this.state });
        }

        return (<TranslationContext.Consumer>{t => {
            const hpTitle = this.props.model.useHp && this.props.model.useHd ? t.caseRun.hpContributors : t.common.contributors;

            return <Form onSubmit={handleSubmit}>
                <SemanticField
                    name="description"
                    component={FormTextArea}
                    label={t.caseRun.runDescription} />

                <FormField>
                    <label>{t.common.population}</label>
                    <Dropdown search selection disabled={this.props.model.aic} options={this.state.populationOptions} value={values.populationId} onChange={dropdownChange} />
                </FormField>
                <FormField>
                    <label>{t.caseRun.numberOfContributors}</label>

                    <Dropdown search selection options={[...Array(Constants.maxNoc).keys()].map(i => (i + 1).toString()).map(m => { return { key: m, value: m, text: m }; })} value={values.numberOfContributors} onChange={(e, data) => dropdownChange(e, data, "numberOfContributors")} />
                </FormField>
                <Grid>
                    <GridRow columns={3}>
                        <GridColumn>
                            <Header attached="top">{hpTitle}</Header>
                            <Segment attached>
                                <List relaxed divided>
                                    {values.hd.map((e, i) => (
                                        <ListItem key={e.id}>
                                            <BPCheckbox disabled={this.props.model.aic} checked={e.selected} label={e.name} onClick={(ev, data) => (hdChecked(e.id, i, data.checked))} />
                                        </ListItem>
                                    ))}
                                </List>
                                <FormField inline error={!!errors.hdUnknowns}>
                                    <label>{t.common.unknowns}</label>
                                    <Field name="hdUnknowns" readOnly={true} />
                                </FormField>
                                <FormField>
                                    <label>{t.caseRun.firstUnknownRelation}</label>
                                    <Dropdown search selection options={Object.getOwnPropertyNames(t.relations).map(m => { return { key: m, value: m, text: t.relations[m] }; })} value={values.hdKnownRelName} onChange={(e, data) => dropdownChange(e, data, "hdKnownRelName")} />
                                </FormField>
                                <FormField>
                                    <label>to</label>
                                    <Dropdown search selection options={(values.hd as Array<any>).concat(values.hd).filter(x => x.selected).map(m => { return { key: m.id, value: m.id, text: m.name }; }).filter((value, index, self) => self.findIndex(c => c.key == value.key) === index)} value={values.hdKnownRelSampleId} onChange={(e, data) => dropdownChange(e, data, "hdKnownRelSampleId")} />
                                </FormField>

                            </Segment>
                        </GridColumn>
                        <GridColumn>
                            {/* <Header attached="top">{t.common.evidence}</Header>
                            <Segment attached>
                                <List relaxed divided>
                                    {values.evidence.map((e, i) => (
                                        <List.Item key={e.id}>
                                            <BPCheckbox disabled={this.props.model.aic} checked={e.selected} label={e.name} onClick={(ev, data) => (evidenceChecked(e.id, i, data.checked))} />
                                        </List.Item>
                                    ))}
                                </List>
                            </Segment> */}
                        </GridColumn>
                    </GridRow>
                </Grid>
                {Object.keys(errors).length > 0 &&
                    <Message negative>
                        <MessageHeader>{t.caseRun.errorsOnForm}</MessageHeader>
                        <MessageList>
                            {Object.keys(errors).map((k) => (<MessageItem key={k}>{errors[k]}</MessageItem>))}
                        </MessageList>
                    </Message>
                }
                <Segment basic clearing>
                    <BPButton floated="right" type="submit" positive primary>{t.caseRun.next}</BPButton>
                </Segment>
            </Form>
        }}</TranslationContext.Consumer>);
    };

    onSubmit = (values: FormState, bag) => {
        this.props.onComplete(values);
        // this.props.router.history.push("/parameters");
    };

    render() {
        return (
            <Formik innerRef={this.form} enableReinitialize={true} initialValues={this.state.initialValues} onSubmit={this.onSubmit} validationSchema={this.FormValidationSchema()}>
                {(props) => {
                    return this.formRender(props)
                }}
            </Formik>
        );
    }
}
